
import React from 'react';
import { Link } from 'react-router-dom';
import { useIsMobile } from '@/hooks/use-mobile';
import { ResponsiveImage } from '@/components/ui/responsive-image';

interface BlogCardProps {
  post: {
    id: number;
    title: string;
    slug: string;
    excerpt: string;
    date: string;
    readTime: string;
    author: string;
    category: string;
    image: string;
    industrySubcategory?: string;
  };
  categoryName: string;
  subcategoryName?: string;
}

const BlogCard: React.FC<BlogCardProps> = ({ post, categoryName, subcategoryName }) => {
  const isMobile = useIsMobile();
  
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300 h-full flex flex-col">
      <Link to={`/blog/${post.slug}`} className="block">
        <div className="relative">
          <ResponsiveImage
            src={post.image}
            alt={post.title}
            width={400}
            height={225}
            mobileWidth={isMobile ? 320 : 400}
            aspectRatio={16/9}
            className="w-full"
          />
          <div className="absolute top-0 left-0 m-3">
            <span className="inline-block bg-itmgmt-bright-blue text-white text-xs font-medium py-1 px-2 rounded">
              {subcategoryName || categoryName}
            </span>
          </div>
        </div>
      </Link>
      
      <div className="p-5 flex-grow flex flex-col">
        <div className="text-sm text-gray-500 mb-2">{post.date} • {post.readTime}</div>
        
        <Link to={`/blog/${post.slug}`} className="block mb-2">
          <h3 className="text-lg font-semibold text-itmgmt-dark-blue hover:text-itmgmt-medium-blue transition-colors line-clamp-2">
            {post.title}
          </h3>
        </Link>
        
        <p className="text-gray-600 text-sm mb-4 line-clamp-3 flex-grow">
          {post.excerpt}
        </p>
        
        <div className="mt-auto flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-8 h-8 rounded-full bg-itmgmt-medium-blue text-white flex items-center justify-center text-xs font-bold">
              {post.author.split(' ').map(word => word[0]).join('')}
            </div>
            <span className="ml-2 text-sm font-medium">{post.author.split(' ')[0]}</span>
          </div>
          
          <Link to={`/blog/${post.slug}`} className="text-sm font-medium text-itmgmt-medium-blue hover:text-itmgmt-bright-blue transition-colors">
            Read more
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
